import { DialogBody } from "@blueprintjs/core";
import { useWrapup } from "../wrapupcontext";
import { WrapupModuleMapData } from "@/src/server/models/seasonal/wrapup/modules/getwrapup";
import getItemById from "@/src/util/getItemById";
import styles from './wrapup.module.css';

export default function WrapupModuleMapsContinuedComponent(): React.ReactNode {
    const { wrapupData } = useWrapup();

    const data = wrapupData.data.map as WrapupModuleMapData;

    return <DialogBody className={styles.dialogBody}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start' }}>
            <h1>Maps Continued</h1>
            <h3>Your top maps:</h3>
            <table>
                <thead>
                    <tr style={{ fontWeight: 'bold' }}>
                        <td></td>
                        <td>Name</td>
                        <td>Plays</td>
                    </tr>
                </thead>
                <tbody>
                    {
                        data.mapPlays.map(
                            (entry) => {
                                const mapId = entry[0];
                                const plays = entry[1];
                                const map = getItemById(wrapupData.maps, mapId);

                                return <tr key={mapId}>
                                    <td>
                                        <picture>
                                            <img
                                                src={`/api/map/getthumbnail?mapId=${mapId}`}
                                                alt={map.name}
                                                draggable={false}
                                                width={32}
                                                height={32}
                                            />
                                        </picture>
                                    </td>
                                    <td>{map.name}</td>
                                    <td>{plays}</td>
                                </tr>
                            }
                        )
                    }
                </tbody>
            </table>
        </div>
    </DialogBody>
}
